import { CTAButton } from 'component/button';
import { useDatastore } from 'util/datastore';
import { canGoBack } from 'util/navigate';
import { t } from 'util/stdtypes';

import { HttpError } from './http-error';

export function Forbidden() {
    const datastore = useDatastore();
    const goBack = () => {
        datastore.goBack();
    };

    return (
        <HttpError
            code='403'
            cta={canGoBack() ? <CTAButton label={t('appError.goHome', 'Go Back')} onPress={goBack} /> : null}
            label={t('appError.page_forbidden', 'Your account cannot access this page.')}
        />
    );
}
